import { Pill } from '@/components/general/Pill';
import MainIcons from '@/icons/main';
import React from 'react';

export default function ViolationBadge() {
  return (
    <Pill color="var(--brand-deep)" bg="var(--tag-bg)">
      <MainIcons.carIcon fill="var(--brand-deep)" width="13px" height="13px" />
      خلافی خودرو
    </Pill>
  );
}
